if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.formIdInput = this.form.querySelector('[name="id"]');
        this.formIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyAtcButton = document.getElementById(
          `StickyAtcSubmitButton-${this.dataset.section}`
        );

        this.skipCart = this.formIdInput.dataset.skipCart === 'true';

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.bundleDeals = document.getElementById(
          `bundle-deals-${this.dataset.section}`
        );

        this.quantityBreaks = document.getElementById(
          `quantity-breaks-${this.dataset.section}`
        );

        this.customFields = document.querySelectorAll(
          `[id^='CustomField-${this.dataset.section}-']`
        );

        this.variantInputs = this.form.querySelector(
          '.product-form__variants'
        );

        /* Browup add-on variant IDs */
        this.shippingProtectionVariantId = '53865744007279';
        this.freeEbookVariantId = '53774624981103';
      }

      async getSingletonAddOnState() {
        const response = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error('Unable to read the cart before adding products.');
        }

        const cartState = await response.json();
        const singletonVariantIds = new Set([
          this.shippingProtectionVariantId,
          this.freeEbookVariantId
        ]);
        const seenVariantIds = new Set();
        const updates = {};

        cartState.items.forEach((item) => {
          const variantId = String(item.variant_id);

          if (!singletonVariantIds.has(variantId)) return;

          if (seenVariantIds.has(variantId)) {
            updates[item.key] = 0;
            return;
          }

          seenVariantIds.add(variantId);

          if (item.quantity !== 1) {
            updates[item.key] = 1;
          }
        });

        if (Object.keys(updates).length > 0) {
          const updateResponse = await fetch(routes.cart_update_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          });

          if (!updateResponse.ok) {
            throw new Error('Unable to normalize cart add-ons.');
          }
        }

        return {
          hasShippingProtection: seenVariantIds.has(
            this.shippingProtectionVariantId
          ),
          hasFreeEbook: seenVariantIds.has(this.freeEbookVariantId)
        };
      }

      getSelectedQuantityRadio() {
        if (!this.quantityBreaks) return null;

        return this.quantityBreaks.querySelector(
          'input[type="radio"][name="quantity"]:checked'
        );
      }

      getSelectedQuantityCard() {
        const selectedRadio = this.getSelectedQuantityRadio();

        if (!selectedRadio) return null;

        const nextElement = selectedRadio.nextElementSibling;

        if (nextElement?.classList?.contains('quantity-break')) {
          return nextElement;
        }

        const radioId = selectedRadio.id;

        if (radioId) {
          return this.quantityBreaks.querySelector(
            `label[for="${CSS.escape(radioId)}"]`
          );
        }

        return null;
      }

      isShippingProtectionEnabled() {
        const selectedCard = this.getSelectedQuantityCard();

        if (!selectedCard) return false;

        const selectedProtection = selectedCard.querySelector(
          '[data-browup-shipping-protection]'
        );

        return selectedProtection?.getAttribute('aria-checked') === 'true';
      }

      addCustomFieldInputs(inputsHtml, itemIndex) {
        this.customFields.forEach((field) => {
          inputsHtml.value += `
            <input
              type="hidden"
              name="items[${itemIndex}][properties][${field.fieldName}]"
              value="${field.prevValue}"
            >
          `;
        });
      }

      addShippingProtectionInput(inputsHtml, itemIndex, shouldAdd) {
        if (!shouldAdd || !this.isShippingProtectionEnabled()) {
          return itemIndex;
        }

        inputsHtml.value += `
          <input
            type="hidden"
            name="items[${itemIndex}][quantity]"
            value="1"
          >
          <input
            type="hidden"
            name="items[${itemIndex}][id]"
            value="${this.shippingProtectionVariantId}"
          >
          <input
            type="hidden"
            name="items[${itemIndex}][properties][_Shipping protection]"
            value="Included"
          >
        `;

        return itemIndex + 1;
      }

      addFreeEbookInput(inputsHtml, itemIndex, shouldAdd) {
        if (!shouldAdd) return itemIndex;

        inputsHtml.value += `
          <input
            type="hidden"
            name="items[${itemIndex}][quantity]"
            value="1"
          >
          <input
            type="hidden"
            name="items[${itemIndex}][id]"
            value="${this.freeEbookVariantId}"
          >
          <input
            type="hidden"
            name="items[${itemIndex}][properties][_Free gift]"
            value="Browup Brow Playbook"
          >
        `;

        return itemIndex + 1;
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();
        this.setLoadingState(true);

        let singletonAddOnState;

        try {
          singletonAddOnState = await this.getSingletonAddOnState();
        } catch (error) {
          console.error(error);
          this.handleErrorMessage(
            'We could not verify your cart. Please try adding the offer again.'
          );
          this.setLoadingState(false);
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        let isMultiItemRequest = false;

        if (this.variantInputs) {
          this.variantInputs.innerHTML = '';
        }

        if (this.bundleDeals && this.variantInputs) {
          const inputsHtml = { value: '' };
          isMultiItemRequest = true;

          for (
            let index = 0;
            index < this.bundleDeals.formVariants.length;
            index += 1
          ) {
            const variant = this.bundleDeals.formVariants[index];

            inputsHtml.value += `
              <input
                type="hidden"
                name="items[${index}][quantity]"
                value="${variant.quantity}"
              >
              <input
                type="hidden"
                name="items[${index}][id]"
                value="${variant.id}"
              >
            `;
          }

          this.variantInputs.innerHTML = inputsHtml.value;
        } else if (this.quantityBreaks && this.variantInputs) {
          const inputsHtml = { value: '' };
          isMultiItemRequest = true;

          const rawFormVariants = Array.isArray(
            this.quantityBreaks.formVariants
          )
            ? this.quantityBreaks.formVariants
            : [];

          /*
           * Keep only the actual Browup kit variants. Shipping Protection and
           * the free eBook are appended once, separately, below.
           */
          const mainProductVariants = rawFormVariants.filter((variant) => {
            const variantId = String(variant.id);

            return (
              variantId !== this.shippingProtectionVariantId &&
              variantId !== this.freeEbookVariantId
            );
          });

          /*
           * Merge repeated selections of the exact same Shopify variant into
           * one cart line. Example: two Soft Black kits become one line with
           * quantity 2 instead of two separate lines.
           *
           * Different shades remain separate because they use different
           * Shopify variant IDs.
           */
          const mergedMainProductVariants = Array.from(
            mainProductVariants
              .reduce((variantMap, variant) => {
                const variantId = String(variant.id);
                const quantity = Math.max(
                  1,
                  Number.parseInt(variant.quantity, 10) || 1
                );

                const existingVariant = variantMap.get(variantId);

                if (existingVariant) {
                  existingVariant.quantity += quantity;
                } else {
                  variantMap.set(variantId, {
                    ...variant,
                    quantity
                  });
                }

                return variantMap;
              }, new Map())
              .values()
          );

          let nextItemIndex = 0;

          /*
           * Shopify displays multi-item additions in reverse request order.
           * Add the singleton products first so the visible cart ends with
           * the eBook followed by Shipping Protection.
           */
          nextItemIndex = this.addShippingProtectionInput(
            inputsHtml,
            nextItemIndex,
            !singletonAddOnState.hasShippingProtection
          );

          nextItemIndex = this.addFreeEbookInput(
            inputsHtml,
            nextItemIndex,
            !singletonAddOnState.hasFreeEbook
          );

          if (mergedMainProductVariants.length > 0) {
            const requestOrderedMainProductVariants = [
              ...mergedMainProductVariants
            ].reverse();

            for (
              let index = 0;
              index < requestOrderedMainProductVariants.length;
              index += 1
            ) {
              const variant = requestOrderedMainProductVariants[index];

              inputsHtml.value += `
                <input
                  type="hidden"
                  name="items[${nextItemIndex}][quantity]"
                  value="${variant.quantity}"
                >
                <input
                  type="hidden"
                  name="items[${nextItemIndex}][id]"
                  value="${variant.id}"
                >
              `;

              this.addCustomFieldInputs(inputsHtml, nextItemIndex);
              nextItemIndex += 1;
            }
          } else {
            /*
             * Fallback used by the one-kit option when quantity-breaks has not
             * populated formVariants yet.
             */
            const selectedQuantityRadio = this.getSelectedQuantityRadio();
            const selectedQuantity = selectedQuantityRadio?.value || '1';
            const selectedVariantId = this.formIdInput.value;

            inputsHtml.value += `
              <input
                type="hidden"
                name="items[${nextItemIndex}][quantity]"
                value="${selectedQuantity}"
              >
              <input
                type="hidden"
                name="items[${nextItemIndex}][id]"
                value="${selectedVariantId}"
              >
            `;

            this.addCustomFieldInputs(inputsHtml, nextItemIndex);
          }

          this.variantInputs.innerHTML = inputsHtml.value;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (isMultiItemRequest) {
          const optionNames = this.dataset.options
            ? this.dataset.options.split(',')
            : [];

          const singleItemFields = ['id', 'quantity', ...optionNames];

          singleItemFields.forEach((fieldName) => {
            formData.delete(fieldName);
          });
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(
                '.sold-out-message'
              );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);

              const buttonLabel = this.submitButton.querySelector('span');
              if (buttonLabel) buttonLabel.classList.add('hidden');

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (this.skipCart) {
              window.location = '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form'
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(
              'Something went wrong while adding the products to your cart.'
            );
          })
          .finally(() => {
            this.setLoadingState(false);

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      setLoadingState(isLoading) {
        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');

          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.remove('hidden');

          if (this.stickyAtcButton) {
            this.stickyAtcButton.classList.add('loading');

            const stickySpinner = this.stickyAtcButton.querySelector(
              '.loading-overlay__spinner'
            );

            if (stickySpinner) stickySpinner.classList.remove('hidden');
          }
        } else {
          this.submitButton.classList.remove('loading');

          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');

          if (this.stickyAtcButton) {
            this.stickyAtcButton.classList.remove('loading');

            const stickySpinner = this.stickyAtcButton.querySelector(
              '.loading-overlay__spinner'
            );

            if (stickySpinner) stickySpinner.classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
